/**
 * Whether Stripe.js actually initialised for this host.
 *
 * Stripe is booted once in `index.tsx`, before the app renders, from the host's
 * publishable key. That can fail — no active Stripe account, the key endpoint
 * erroring, or a key Stripe.js refuses (a restricted `rk_…` or secret `sk_…`
 * key pasted into the publishable-key field makes `loadStripe` reject).
 *
 * When it fails there is no visible symptom on its own: `<Elements>` never
 * receives a Stripe instance, so the card fields render as empty, unclickable
 * boxes and the renter simply cannot pay (1NOW-1608). Checkout awaits this to
 * show a real message instead.
 *
 * A promise rather than a boolean because `loadStripe` settles after boot — the
 * app must not block its first paint on Stripe.js downloading.
 */
let availability: Promise<boolean> = Promise.resolve(false);

export const setStripeAvailability = (next: Promise<boolean>): void => {
  availability = next;
};

export const getStripeAvailability = (): Promise<boolean> => availability;
